/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotteryClassTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotteryClass,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Crafty!",
    "Artistic Creations Await!",
    "Clay and Creativity!",
  ],
  title: "Pottery Class",
  description: "Organize a fun pottery class.",
  longDescription:
    "Gather your friends for a creative pottery class! Choose a date, decide on the pieces to make, and plan snacks for the session!",
  emoji: "🖌",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Pottery Class",
          emoji: "🖌",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the pottery class?",
          emoji: "📅",
          completeAction: {
            question: "Decide on pottery pieces to create?",
            description: "What pottery pieces should we make in the class?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What pottery pieces should we create?",
                emoji: "🍶",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have during the class?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍪",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "☕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Creative!",
    outroDescription:
      "Your pottery class plans are set! Enjoy crafting with clay!",
  },
};
